import { Injectable, Inject } from '@angular/core';
import { ToastContainerDirective, GlobalConfig, ToastrService } from 'ngx-toastr';
import { BlackToastComponent } from '../../components/black-toast/black-toast.component';

@Injectable()

export class ToastService {
    toastrOptions: GlobalConfig;

    constructor(
        private _toastrService: ToastrService
    ) {
        this.toastrOptions = this._toastrService.toastrConfig;
    }


    showBlackToast(message,options:any = {}) {
        const opt = Object.assign({},this.toastrOptions,options); //cloneDeep(this.toastrOptions);
        opt.toastComponent = BlackToastComponent;
        opt.toastClass = 'blacktoast';
        this._toastrService.show(message, '', opt);
    }

    clearAllBlackToast() {
        this._toastrService.clear();
    }
}
